import PostListPage from '~components/post-list-page'

export default PostListPage({
  path: '/domain/:domain',
  title: 'Perfiles del dominio',
  sort: '-karma'
})



// WEBPACK FOOTER //
// ../frontend/pages/post/list-domain.js